export default __webpack_public_path__ + "static/media/Packages-Active.bed716cf.svg";